module.exports = __webpack_public_path__ + "img/winners-logo.736b76af.png";